import { Button, Modal, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import ConfigProviderCustomize from 'components/ConfigProviderCustomize';
import { ContainerTable } from 'components/styles/table';
import { useToast } from 'components/Toast';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser } from 'store/user/shared/selectors';
import _ from 'lodash';
import { selectListTeacher } from 'store/teacher/shared/selectors';
import * as FromTeacherSlice from '../../../store/teacher/shared/slice';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { TeacherSaga } from 'store/teacher/shared/saga';
import SearchInput from 'components/AntCustom/SearchInput';
import Pagination from 'components/Pagination';

interface ModelSelectTeacherPhongProps {
  open: boolean;
  listTeacherChoose: any[];
  handleCancel: () => void;
  handleSuccess: (teacher: any[]) => void;
  courseId: any;
}

interface DataType {
  teacher_fullname: string;
  id_num: string;
  birthday: Date;
  phone_number: string;
  position_title: string;
  ma_cong_chuc: string;
  subject_name: string;
  action: string;
  school_id: string;
}

function ModelSelectTeacherPhong({
  open,
  listTeacherChoose,
  handleCancel,
  handleSuccess,
  courseId
}: ModelSelectTeacherPhongProps) {
  useInjectReducer({ key: FromTeacherSlice.sliceKey, reducer: FromTeacherSlice.reducer });
  useInjectSaga({ key: FromTeacherSlice.sliceKey, saga: TeacherSaga });
  const dispatch = useDispatch();
  const toast = useToast();
  const listTeacher: any = useSelector(selectListTeacher);
  // const loading: boolean = useSelector(selectLoading);
  const user = useSelector(selectAuthUser);

  const [filterData, setFilterData] = useState({
    keyword: '',
    subjectId: 0,
    perPage: 10,
    pageId: 1,
    schoolId: user?.schools?.[0]?.school_id
  });

  const [valueSelect, setValueSelect] = useState<any[]>([]);
  const [otherUser, setOtherUser] = useState<any>(null);
  const [valueSelectId, setValueSelectId] = useState<any[]>([]);

  const [userIdCreate, setUserIdCreate] = useState<any>();
  const [isLoginSSO, setIsLoginSSO] = useState<boolean>(false);

  useEffect(() => {
    if (filterData.schoolId) {
      dispatch(FromTeacherSlice.actions.getListTeacher(filterData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);

  useEffect(() => {
    if (listTeacherChoose) {
      setUserIdCreate(listTeacherChoose[0].userId_create);
      setValueSelectId(listTeacherChoose.map((item) => item.user_id));
      setOtherUser(listTeacherChoose[0].other_user);
    }
    if (!_.isEmpty(user?.user_logintype_code)) {
      setIsLoginSSO(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listTeacherChoose]);

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      const dataSelected = selectedRows.filter((item: any) => item.user_id !== userIdCreate);
      if (dataSelected.length > 0) {
        setValueSelect(selectedRows);
        setValueSelectId(selectedRows.map((itm: any) => itm.user_id));
      } else {
        toast?.pushWarning('Không phân quyền chuyên viên chấm sáng kiến của mình!');
      }
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.user_id === otherUser?.user_id, // Column configuration not to be checked
      name: record.teacher_fullname
    })
  };

  const handleNext = () => {
    const newFilter = Object.assign({}, filterData, {
      pageId: filterData.pageId + 1
    });
    setNewFilters(newFilter);
  };

  const handleRev = () => {
    if (filterData.pageId === 1) return;
    const newFilter = Object.assign({}, filterData, {
      pageId: filterData.pageId - 1
    });
    setNewFilters(newFilter);
  };

  const selectPerpage = (e) => {
    const newFilter = Object.assign({}, filterData, {
      pageId: 1,
      perPage: Number(e.key)
    });
    setNewFilters(newFilter);
  };

  const isCheckDisable = useCallback((): boolean | undefined => {
    if (!_.isEmpty(listTeacher)) {
      if (listTeacher.teacher_records.length < filterData.perPage) return true;
      return false;
    }
  }, [filterData.perPage, listTeacher]);

  const setNewFilters = (newFilter) => {
    setFilterData(newFilter);
  };

  const handleSearch = (value?: string): any => {
    const newFilter = Object.assign({}, filterData, {
      keyword: value,
      perPage: 10,
      pageId: 1
    });
    setNewFilters(newFilter);
  };

  const handleSubmit = () => {
    if (valueSelect.length > 0) {
      handleSuccess(valueSelect);
      handleCancel();
    }
  };

  const handleToggleRow = (record: any) => {
    if (otherUser?.user_id === record.user_id) {
      return;
    }

    setValueSelect([record]);
    setValueSelectId([record.user_id]);
  };

  const columns: ColumnsType<DataType> = [
    {
      title: 'STT',
      width: 100,
      align: 'center',
      onHeaderCell: (record) => {
        return {
          record,
          style: { background: '#91d5ff' }
        };
      },
      render: (text, record, index) => {
        return <span>{(filterData.pageId - 1) * filterData.perPage + index + 1}</span>;
      }
    },
    {
      title: isLoginSSO ? 'Mã định danh bộ' : 'Mã công chức',
      dataIndex: isLoginSSO ? 'teacher_code' : 'ma_cong_chuc',
      key: isLoginSSO ? 'teacher_code' : 'ma_cong_chuc',
      width: 100,
      align: 'center',
      onHeaderCell: (record) => {
        return {
          record,
          style: { background: '#91d5ff' }
        };
      },
      render: (record) => {
        if (!_.isEmpty(record)) {
          return <span style={{ color: '#1890ff' }}>{record}</span>;
        }
        return <span style={{ color: '#ea5455' }}>--.--</span>;
      }
    },
    {
      title: 'Họ tên giáo viên',
      dataIndex: 'teacher_fullname',
      key: 'teacher_fullname',
      width: 300,
      align: 'center',
      onHeaderCell: (record) => {
        return {
          record,
          style: { background: '#91d5ff' }
        };
      },
      render: (record) => {
        if (!_.isEmpty(record)) {
          return <span style={{ color: '#1890ff' }}>{record}</span>;
        }
        return <span style={{ color: '#ea5455' }}>--.--</span>;
      }
    }
  ];

  return (
    <Modal
      title="Chọn chuyên viên chấm điểm"
      centered
      visible={open}
      onCancel={() => handleCancel()}
      width={600}
      maskClosable={false}
      footer={[
        <Button key="back" size="large" onClick={handleCancel}>
          Đóng
        </Button>,
        <Button key="submit" size="large" type="primary" onClick={handleSubmit}>
          Lưu
        </Button>
      ]}>
      <ContainerTable>
        <ConfigProviderCustomize>
          <Table
            rowSelection={{
              type: 'radio',
              selectedRowKeys: valueSelectId,
              ...rowSelection
            }}
            showHeader
            columns={columns}
            style={{ height: ' 50vh', overflow: ' auto' }}
            dataSource={listTeacher?.teacher_records}
            onRow={(record, rowIndex) => ({
              onClick: (event) => handleToggleRow(record)
            })}
            title={(currentPageData) => {
              return (
                <div>
                  <SearchInput
                    allowClear
                    placeholder="Họ tên chuyên viên"
                    onSearch={handleSearch}
                    enterButton
                  />
                </div>
              );
            }}
            size="middle"
            bordered
            pagination={false}
            // loading={loading}
            rowKey={(record: any) => record.user_id}
          />
        </ConfigProviderCustomize>
      </ContainerTable>
      <div className="mt-30">
        <Pagination
          current={filterData.pageId}
          onClickNext={() => handleNext()}
          onClickRev={() => handleRev()}
          rowsPerPage={filterData.perPage}
          onClickPerpage={selectPerpage}
          isDisableNext={isCheckDisable()}
        />
      </div>
    </Modal>
  );
}

export default ModelSelectTeacherPhong;
